// extracted by mini-css-extract-plugin
module.exports = {"MinMaxDimensionsFeature":"ka_a"};